import { AddOn, Product } from "../../../../data/entities";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../shared/components/CustomTable/Styled";
import {
    ProductFilterType,
    valueToText,
} from "../../../../configs/filterTypes";
import Status from "../../../../shared/components/Status";
import StatusActive from "../../../../shared/components/StatusActive";
import { PRODUCT_CATEGORY } from "../../../../data/enums";
import { StyledNavLink } from "../../../../shared/styled/TableStyles";
import { formatCurrency } from "../../../../utils/format";

const getCategoryColorTheme = (category: string) => {
    switch (category) {
        case PRODUCT_CATEGORY.BARREL:
            return "SUCCESS";
        case PRODUCT_CATEGORY.VESSEL:
            return "WARNING";
        case PRODUCT_CATEGORY.VEHICLE:
            return "INFO";
        default:
            return "INFO";
    }
};

export const AddOnRow = ({ item }: { item: AddOn }) => {
    const formattedPrice = formatCurrency(item.price);

    return (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLink to={`/addons/${item.id}`}>
                    {item.id}
                </StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">{item.name}</StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    colorTheme={getCategoryColorTheme(item.category)}
                    text={valueToText(
                        ProductFilterType,
                        "category",
                        item.category
                    )}
                    width="124px"
                />
            </StyledTableCell>
            <StyledTableCell align="left">{formattedPrice}</StyledTableCell>
        </TableRow>
    );
};
